import UserSession from "network/UserSession";

interface Dictionary<T> {
  [key: string]: T;
}

export enum JorneyToHomeArea {
  "Square" = 0,
  "Sky" = 1,
  "Forest" = 2,
  "River" = 3,
  "City" = 4,
}

export enum J2HGameState {
  WAITING,
  START,
  END,
}

export interface J2HPlayer {
  id: number;
  isHost: boolean;
  name: string;
  score: string;
  home: JorneyToHomeArea;
  lastArea: JorneyToHomeArea;
  currentArea: JorneyToHomeArea;
}

// "Square" = 0,
// "Sky" = 1,
// "Land" = 2,
// "River" = 3,
// "City" = 4,
export interface J2HState {
  playerList: J2HPlayer[];
  mode: number;
  areaHomeCountArray: number[];
  areaCurrentPlayerList: Dictionary<J2HPlayer[]>;
  score: number;
  round: number;
  leftTime: number;
  state: J2HGameState;
  lastArea: JorneyToHomeArea;
  currentArea: JorneyToHomeArea;
  selectedArea: JorneyToHomeArea;
  disabledAreas: JorneyToHomeArea[]; // TODO: event or saboteur
}

const defaultAreaCurrentPlayerList: Dictionary<J2HPlayer[]> = {
  0: [],
  1: [],
  2: [],
  3: [],
  4: [],
  5: [],
};

export const initialJ2HState: J2HState = {
  playerList: [],
  areaHomeCountArray: [0, 0, 0, 0, 0],
  areaCurrentPlayerList: defaultAreaCurrentPlayerList,
  score: 0,
  mode: 0,
  round: -1,
  leftTime: 0,
  lastArea: 0,
  state: J2HGameState.WAITING,
  currentArea: JorneyToHomeArea.Square,
  selectedArea: JorneyToHomeArea.Square,
  disabledAreas: [],
};

type J2HAction =
  | { type: "START_GAME" }
  | { type: "END_GAME" }
  | {
      type: "READY_ROUND";
      round: number;
      leftTime: number;
      playerStates: J2HPlayer[];
      mode: number;
    }
  | { type: "SELECT_DESTINATION"; selectedArea: JorneyToHomeArea }
  | {
      type: "SET_DISABLED_DESTINATIONS";
      disabledList: JorneyToHomeArea[];
    }
  | {
      type: "START_ROUND";
      playerStates: J2HPlayer[];
      roundTime: number;
      areaHomeCountArray: number[];
    }
  | { type: "INCREMENT_SCORE" }
  | { type: "DECREMENT_TIME" }
  | { type: "LOSE_LIFE" }
  | { type: "PAUSE_GAME"; isPaused: boolean }
  | { type: "INCREASE_LEVEL" };

export function j2hReducer(state: J2HState, action: J2HAction): J2HState {
  switch (action.type) {
    case "READY_ROUND":
      return {
        ...state,
        state: J2HGameState.START,
        areaCurrentPlayerList: {
          ...defaultAreaCurrentPlayerList,
          [JorneyToHomeArea.Square]: action.playerStates,
        },
        currentArea: JorneyToHomeArea.Square,
        selectedArea: JorneyToHomeArea.Square,
        disabledAreas: [],
        leftTime: action.leftTime,
        round: action.round,
        mode: action.mode,
      };
    case "DECREMENT_TIME":
      return { ...state, leftTime: state.leftTime - 1 };
    case "SELECT_DESTINATION":
      return { ...state, selectedArea: action.selectedArea };
    case "SET_DISABLED_DESTINATIONS":
      return { ...state, disabledAreas: action.disabledList };
    case "START_ROUND":
      // reset dicts
      Object.keys(state.areaCurrentPlayerList).forEach((key) => [
        (state.areaCurrentPlayerList[key] = []),
      ]);

      var currentArea = state.currentArea;
      var lastArea = state.lastArea;
      action.playerStates.forEach((player) => {
        let playerArea = player.currentArea;
        // find my area
        if (player.id === UserSession.getInstance().user.id) {
          lastArea = player.lastArea;
          currentArea = playerArea;
        }

        state.areaCurrentPlayerList[playerArea].push(player);
      });

      return {
        ...state,
        playerList: action.playerStates,
        leftTime: action.roundTime,
        currentArea: currentArea,
        lastArea: lastArea,
        areaHomeCountArray: action.areaHomeCountArray,
      };
    default:
      break;
  }
  switch (action.type) {
    // case "START_GAME":
    //   return { ...initialJ2HState, isGameOver: false };
    // case "END_GAME":
    //   return {
    //     ...state,
    //     isGameOver: true,
    //     highScore: Math.max(state.highScore, state.score),
    //   };
    // case "INCREMENT_SCORE":
    //   return { ...state, score: state.score + 1 + state.bonusPoints };
    // case "DECREMENT_TIME":
    //   const newTimeLeft = state.timeLeft - 1;
    //   if (newTimeLeft <= 0) {
    //     return {
    //       ...state,
    //       timeLeft: 0,
    //       isGameOver: true,
    //       highScore: Math.max(state.highScore, state.score),
    //     };
    //   }
    //   return { ...state, timeLeft: newTimeLeft };
    // case "LOSE_LIFE":
    //   const newLives = state.lives - 1;
    //   return { ...state, lives: newLives, isGameOver: newLives <= 0 };
    // case "PAUSE_GAME":
    //   return { ...state, isPaused: action.isPaused };
    // case "INCREASE_LEVEL":
    //   return { ...state, level: state.level + 1 };
    default:
      return state;
  }
}

// export const startGame = (
//   setGameState: React.Dispatch<React.SetStateAction<J2HState>>
// ) => {
//   setGameState({
//     ...initialGameState,
//     isGameOver: false,
//   });
// };

// export const endGame = (
//   setGameState: React.Dispatch<React.SetStateAction<J2HState>>
// ) => {
//   setGameState((prevState) => ({
//     ...prevState,
//     isGameOver: true,
//   }));
// };

// export const incrementScore = (
//   setGameState: React.Dispatch<React.SetStateAction<J2HState>>
// ) => {
//   setGameState((prevState) => ({
//     ...prevState,
//     score: prevState.score + 1,
//   }));
// };

// export const decrementTime = (
//   setGameState: React.Dispatch<React.SetStateAction<J2HState>>
// ) => {
//   setGameState((prevState) => {
//     const newTimeLeft = prevState.timeLeft - 1;
//     if (newTimeLeft <= 0) {
//       return {
//         ...prevState,
//         timeLeft: 0,
//         isGameOver: true,
//       };
//     }
//     return {
//       ...prevState,
//       timeLeft: newTimeLeft,
//     };
//   });
// };
